// @ts-nocheck
function render(canvas, config = {}): any {
    // If there is no element canvas
    if (!(canvas instanceof HTMLCanvasElement)) {
        console.error('Is not an element canvas...');
        return;
    }

    // ------------------------------------------------------------------------

    // Get context 2d
    const context = canvas.getContext('2d');

    // Clip the image and position the clipped part on the canvas
    if (config.sX && config.sY && config.sWidth && config.sHeight) {
        context.drawImage(
            canvas,
            config.sX,
            config.sY,
            config.sWidth,
            config.sHeight,
            config.x,
            config.y,
            config.width,
            config.height,
        );
    }
    // Position the image on the canvas, and specify width and height of the image
    else if (config.width && config.height) {
        context.drawImage(canvas, config.x, config.y, config.width, config.height);
    }
    // Position the image on the canvas
    else {
        context.drawImage(canvas, config.x, config.y);
    }
}

function renderFrame(callback, fps = 24): any {
    setTimeout(function (): any {
        requestAnimationFrame(callback);
    }, 1000 / fps);
}

function renderControl(callback, fps = 30): any {
    let delay = 1000 / fps;
    let time = null;
    let frame = -1;
    let tref;

    function loop(timestamp): any {
        if (time === null) {
            time = timestamp;
        }

        const seg = Math.floor((timestamp - time) / delay);

        if (seg > frame) {
            frame = seg;

            callback({
                frame: frame,
                time: timestamp,
            });
        }

        tref = requestAnimationFrame(loop);
    }

    // ------------------------------------------------------------------------

    // Is Playing
    let isPlaying = false;

    function start(): any {
        if (isPlaying) {
            return;
        }

        isPlaying = true;

        tref = requestAnimationFrame(loop);
    }

    function pause(): any {
        if (!isPlaying) {
            return;
        }

        cancelAnimationFrame(tref);

        isPlaying = false;

        frame = -1;
        time = null;
    }

    function frameRate(value): any {
        if (!arguments.length) {
            return fps;
        }

        fps = value;
        delay = 1000 / fps;
        frame = -1;
        time = null;
    }

    // ------------------------------------------------------------------------

    return {
        frameRate,
        isPlaying,
        pause,
        start,
    };
}

export { render, renderControl, renderFrame };
